(() => {
  const english = document.documentElement.lang.startsWith('en');
  let pagePointerFrame = 0;
  let pagePointer = null;
  document.addEventListener('pointermove', event => {
    if (event.pointerType !== 'mouse' || document.querySelector('.mv-free') || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    pagePointer = {x:event.clientX,y:event.clientY};
    if (pagePointerFrame) return;
    pagePointerFrame = requestAnimationFrame(() => {
      pagePointerFrame = 0;
      const surface = document.querySelector('.mellven-page-surface');
      if (!surface) return;
      surface.style.setProperty('--mv-page-x', pagePointer.x + 'px');
      surface.style.setProperty('--mv-page-y', pagePointer.y + 'px');
      surface.style.setProperty('--mv-page-glow', '1');
      surface.style.setProperty('--mv-page-dx', ((pagePointer.x / innerWidth - .5) * 90) + 'px');
      surface.style.setProperty('--mv-page-dy', ((pagePointer.y / innerHeight - .5) * 65) + 'px');
    });
  }, {passive:true});
  document.documentElement.addEventListener('pointerleave', () => document.querySelector('.mellven-page-surface')?.style.setProperty('--mv-page-glow','0'));
  const preference = matchMedia('(prefers-reduced-motion: reduce)');
  const cleanup = new WeakMap();
  const clamp = (value, min, max) => Math.max(min, Math.min(max, value));
  const scroller = () => {
    const page = document.querySelector('.page-wrapper');
    return page && /auto|scroll/.test(getComputedStyle(page).overflowY) && page.scrollHeight > page.clientHeight ? page : window;
  };
  const initHeader = () => document.querySelectorAll('[data-mv-header]').forEach(header => {
    if (header.dataset.mvReady) return;
    header.dataset.mvReady = 'true';
    const toggle = header.querySelector('.mv-header__toggle');
    const setOpen = open => {
      header.dataset.menuOpen = String(open);
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? (english ? 'Close menu' : 'Fechar menu') : (english ? 'Open menu' : 'Abrir menu'));
      toggle.lastElementChild.textContent = open ? '−' : '＋';
    };
    toggle.addEventListener('click', () => setOpen(header.dataset.menuOpen !== 'true'));
    header.addEventListener('keydown', event => {
      if (event.key === 'Escape' && header.dataset.menuOpen === 'true') { setOpen(false); toggle.focus(); }
    });
    header.querySelectorAll('nav a').forEach(link => link.addEventListener('click', () => setOpen(false)));
    document.addEventListener('pointerdown', event => { if (!header.contains(event.target)) setOpen(false); });
  });
  const initHome = root => {
    if (root.dataset.mvReady) return;
    root.dataset.mvReady = 'true';
    const controller = new AbortController();
    const options = { signal: controller.signal };
    const hero = root.querySelector('[data-mv-hero]');
    const scene = root.querySelector('[data-mv-scene]');
    const introSurface = root.closest('.mellven-page-surface') || root;
    const introBackdrop = document.createElement('div');
    introBackdrop.className = 'mv-intro-backdrop';
    introBackdrop.setAttribute('aria-hidden', 'true');
    introBackdrop.innerHTML = '<svg viewBox="0 0 1600 1000" preserveAspectRatio="none"><path d="M480-80C180 160 450 330 930 230S1410-50 1710 100M-70 180C130 130 80 480 570 570S1000 470 1310 790S1600 530 1700 620M-80 960C180 870 190 680 470 790S890 1110 1220 940S1490 730 1720 900"/></svg>';
    introSurface.prepend(introBackdrop);
    document.body.classList.add('mv-homepage');
    const scroll = scroller();
    let frame = 0;
    let active = true;
    let pointerX = 0;
    let pointerY = 0;
    let x = 0;
    let y = 0;
    let progress = 0;
    let heroTop = 0;
    let heroHeight = 1;
    let viewHeight = innerHeight;
    let introHeight = 1;
    const measure = () => {
      const rect = hero.getBoundingClientRect();
      const offset = scroll === window ? scrollY : scroll.scrollTop;
      const top = scroll === window ? 0 : scroll.getBoundingClientRect().top;
      heroTop = rect.top - top + offset;
      heroHeight = rect.height;
      viewHeight = scroll === window ? innerHeight : scroll.clientHeight;
      introHeight = Math.max(1, rect.bottom - introSurface.getBoundingClientRect().top);
      introBackdrop.style.height = `${introHeight}px`;
    };
    const paint = () => {
      frame = 0;
      if (preference.matches || !active) return;
      const current = scroll === window ? scrollY : scroll.scrollTop;
      const desiredProgress = clamp((current - heroTop) / Math.min(heroHeight, viewHeight), 0, 1);
      x += (pointerX - x) * .09;
      y += (pointerY - y) * .09;
      progress += (desiredProgress - progress) * .12;
      scene.style.setProperty('--mv-mouse-x', `${(x * 10).toFixed(2)}px`);
      scene.style.setProperty('--mv-rotate-x', `${(-y * 5 + progress * 7).toFixed(2)}deg`);
      scene.style.setProperty('--mv-rotate-y', `${(x * 7 + progress * 10).toFixed(2)}deg`);
      scene.style.setProperty('--mv-symbol-y', `${(progress * 60 + y * 7).toFixed(2)}px`);
      scene.style.setProperty('--mv-symbol-turn', `${(-5 + progress * 11).toFixed(2)}deg`);
      scene.style.setProperty('--mv-symbol-scale', (1 - progress * .07).toFixed(3));
      scene.style.setProperty('--mv-glimpse-y', `${(-progress * 42 - y * 5).toFixed(2)}px`);
      scene.style.setProperty('--mv-shadow-scale', (1 - progress * .18).toFixed(3));
      hero.style.setProperty('--mv-cursor-x', `${((x + 1) * 50).toFixed(2)}%`);
      hero.style.setProperty('--mv-cursor-y', `${((y + 1) * 50).toFixed(2)}%`);
      hero.style.setProperty('--mv-contour-x', `${(x * 48).toFixed(2)}px`);
      hero.style.setProperty('--mv-contour-y', `${(y * 36).toFixed(2)}px`);
      introBackdrop.style.setProperty('--mv-cursor-x', `${((x + 1) * 50).toFixed(2)}%`);
      introBackdrop.style.setProperty('--mv-cursor-y', `${((y + 1) * 50).toFixed(2)}%`);
      introBackdrop.style.setProperty('--mv-contour-x', `${(x * 48).toFixed(2)}px`);
      introBackdrop.style.setProperty('--mv-contour-y', `${(y * 36).toFixed(2)}px`);
      if (Math.abs(pointerX - x) + Math.abs(pointerY - y) + Math.abs(desiredProgress - progress) > .004) frame = requestAnimationFrame(paint);
    };
    const schedule = () => { if (!frame && active && !preference.matches) frame = requestAnimationFrame(paint); };
    introSurface.addEventListener('pointermove', event => {
      if (event.pointerType !== 'mouse') return;
      const rect = introSurface.getBoundingClientRect();
      if (event.clientY - rect.top > introHeight) { hero.dataset.mvHover = 'false'; introBackdrop.dataset.mvHover = 'false'; return; }
      pointerX = clamp((event.clientX - rect.left) / rect.width * 2 - 1, -1, 1);
      pointerY = clamp((event.clientY - rect.top) / introHeight * 2 - 1, -1, 1);
      hero.dataset.mvHover = 'true';
      introBackdrop.dataset.mvHover = 'true';
      schedule();
    }, options);
    introSurface.addEventListener('pointerleave', () => { pointerX = 0; pointerY = 0; hero.dataset.mvHover = 'false'; introBackdrop.dataset.mvHover = 'false'; schedule(); }, options);
    scroll.addEventListener('scroll', schedule, { passive: true, signal: controller.signal });
    window.addEventListener('resize', () => { measure(); schedule(); }, options);
    const introResize = new ResizeObserver(() => { measure(); schedule(); });
    introResize.observe(hero);
    const headerGroup = document.querySelector('#header-group');
    if (headerGroup) introResize.observe(headerGroup);
    const visibility = new IntersectionObserver(entries => {
      active = entries[0].isIntersecting;
      if (active) { measure(); schedule(); } else { cancelAnimationFrame(frame); frame = 0; }
    }, { root: scroll === window ? null : scroll, rootMargin: '100px' });
    visibility.observe(hero);
    preference.addEventListener('change', () => {
      if (preference.matches) { cancelAnimationFrame(frame); frame = 0; scene.removeAttribute('style'); hero.dataset.mvHover = 'false'; introBackdrop.dataset.mvHover = 'false'; }
      else schedule();
    }, options);
    const symbol = root.querySelector('[data-mv-symbol]');
    const launch = root.querySelector('[data-mv-launch]');
    let flight = null;
    let flameFlight = null;
    const rocketFlame = document.createElement("span");
    rocketFlame.className = "mv-rocket-flame";
    rocketFlame.setAttribute("aria-hidden", "true");
    symbol?.append(rocketFlame);
    let landing = null;
    let fireworksFrame = 0;
    let finishFireworks = null;
    const fireworks = document.createElement('canvas');
    fireworks.className = 'mv-fireworks';
    fireworks.setAttribute('aria-hidden', 'true');
    hero.append(fireworks);
    const fireworksContext = fireworks.getContext('2d');
    const explode = () => new Promise(resolve => {
      if (preference.matches || !fireworksContext || !active) { resolve(); return; }
      finishFireworks = resolve;
      hero.dataset.mvFireworks = 'true';
      const width = hero.clientWidth;
      const height = hero.clientHeight;
      const density = Math.min(devicePixelRatio || 1, 2);
      fireworks.width = Math.round(width * density);
      fireworks.height = Math.round(height * density);
      fireworksContext.setTransform(density, 0, 0, density, 0, 0);
      const count = width < 750 ? 34 : 60;
      const colours = ['#00875a', '#00ad6a', '#39bb75', '#087349', '#73cc83'];
      const bursts = [
        {x:width*.72,y:height*.16,delay:0,strength:1.35},
        {x:width*.28,y:height*.23,delay:220,strength:1.15},
        {x:width*.5,y:height*.46,delay:420,strength:1.25},
        {x:width*.88,y:height*.42,delay:640,strength:1.05},
        {x:width*.12,y:height*.6,delay:830,strength:1.15},
        {x:width*.7,y:height*.7,delay:1050,strength:1.25},
        {x:width*.36,y:height*.76,delay:1270,strength:1.1},
        {x:width*.54,y:height*.18,delay:1480,strength:1.3}
      ];
      const particles = bursts.flatMap(burst => Array.from({ length: count }, (_, index) => {
        const angle = index / count * Math.PI * 2 + (Math.random() - .5) * .09;
        const speed = (90 + Math.random() * 125) * burst.strength;
        return { ...burst, vx: Math.cos(angle) * speed, vy: Math.sin(angle) * speed, lifetime: 1.7 + Math.random() * .6, colour: colours[index % colours.length], size: 1 + Math.random() * 1.2 };
      }));
      const start = performance.now();
      const draw = now => {
        fireworksContext.clearRect(0, 0, width, height);
        const elapsed = now - start;
        let remaining = false;
        particles.forEach(particle => {
          const age = (elapsed - particle.delay) / 1000;
          if (age < 0) { remaining = true; return; }
          if (age >= particle.lifetime) return;
          remaining = true;
          const oldAge = Math.max(0, age - .045);
          const px = particle.x + particle.vx * age;
          const py = particle.y + particle.vy * age + 65 * age * age;
          const oldX = particle.x + particle.vx * oldAge;
          const oldY = particle.y + particle.vy * oldAge + 65 * oldAge * oldAge;
          fireworksContext.globalAlpha = Math.pow(1 - age / particle.lifetime, .75);
          fireworksContext.strokeStyle = particle.colour;
          fireworksContext.lineWidth = particle.size;
          fireworksContext.lineCap = 'round';
          fireworksContext.beginPath();
          fireworksContext.moveTo(oldX, oldY);
          fireworksContext.lineTo(px, py);
          fireworksContext.stroke();
          fireworksContext.fillStyle = particle.colour;
          fireworksContext.beginPath();
          fireworksContext.arc(px, py, particle.size, 0, Math.PI * 2);
          fireworksContext.fill();
        });
        bursts.forEach(burst => {
          const age = (elapsed - burst.delay) / 1000;
          if (age < 0 || age > .55) return;
          fireworksContext.globalAlpha = (1 - age / .55) * .45;
          fireworksContext.strokeStyle = '#00875a';
          fireworksContext.lineWidth = 1;
          fireworksContext.beginPath();
          fireworksContext.arc(burst.x, burst.y, 8 + age * 110, 0, Math.PI * 2);
          fireworksContext.stroke();
        });
        fireworksContext.globalAlpha = 1;
        if (remaining && active && !controller.signal.aborted && !preference.matches) fireworksFrame = requestAnimationFrame(draw);
        else { fireworksContext.clearRect(0, 0, width, height); hero.dataset.mvFireworks = 'false'; fireworksFrame = 0; finishFireworks = null; resolve(); }
      };
      fireworksFrame = requestAnimationFrame(draw);
    });
    if (launch && symbol) launch.addEventListener('click', () => {
      if (launch.disabled) return;
      launch.disabled = true;
      symbol.dataset.mvFlying = 'true';
      hero.dataset.mvLaunching = 'true';
      rocketFlame.dataset.active = preference.matches ? "false" : "true";
      const ascent = Math.max(hero.clientHeight * .8, symbol.clientHeight * .95);
      const frames = preference.matches ? [{ opacity: 1 }, { opacity: .3 }, { opacity: 1 }] : [
        {transform:'translate(0px,0px) rotate(0deg)',opacity:1},
        {transform:'translate(18px,-65px) rotate(-26deg)',opacity:1,offset:.25},
        {transform:`translate(70px,-${ascent}px) rotate(-26deg)`,opacity:0}
      ];
      flight = launch.animate(frames, { duration: preference.matches ? 280 : 1050, easing: 'cubic-bezier(.7,0,1,1)', fill: 'forwards' });
      if (!preference.matches) flameFlight = rocketFlame.animate(frames,{duration:1050,easing:"cubic-bezier(.7,0,1,1)",fill:"forwards"});
      flight.onfinish = async () => {
        rocketFlame.dataset.active = "false";
        flameFlight?.cancel();
        await explode();
        if (controller.signal.aborted) return;
        flight.cancel();
        symbol.dataset.mvFlying = 'false';
        hero.dataset.mvLaunching = 'false';
        landing = launch.animate([{ opacity: 0 }, { opacity: 1 }], { duration: preference.matches ? 1 : 250, easing: 'ease-out' });
        landing.onfinish = () => { launch.disabled = false; };
      };
    }, options);
    const tabs = [...root.querySelectorAll('[data-mv-tab]')];
    const panels = [...root.querySelectorAll('[data-mv-panel]')];
    const select = name => {
      tabs.forEach(tab => { const selected = tab.dataset.mvTab === name; tab.setAttribute('aria-selected', String(selected)); tab.tabIndex = selected ? 0 : -1; });
      panels.forEach(panel => { if (panel.dataset.mvPanel === name) panel.querySelectorAll('[data-mv-reveal]').forEach(element => { element.dataset.mvReveal = 'seen'; }); });
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => select(tab.dataset.mvTab), options);
      tab.addEventListener('keydown', event => {
        let next = null;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next !== null) { event.preventDefault(); tabs[next].focus(); select(tabs[next].dataset.mvTab); }
      }, options);
    });
    root.querySelectorAll('[data-mv-comparison]').forEach(comparison => {
      const range = comparison.querySelector('input');
      const update = () => { comparison.style.setProperty('--mv-compare', `${range.value}%`); range.setAttribute('aria-valuetext', english ? `${range.value} per cent before, ${100 - Number(range.value)} per cent after` : `${range.value} por cento antes, ${100 - Number(range.value)} por cento depois`); };
      range.addEventListener('input', update, options);
      update();
    });
    root.querySelectorAll('a[href^="#"]').forEach(link => link.addEventListener('click', event => {
      const target = document.getElementById(link.hash.slice(1));
      if (!target) return;
      event.preventDefault();
      if (link.dataset.mvPick) select(link.dataset.mvPick);
      target.scrollIntoView({ behavior: preference.matches ? 'auto' : 'smooth', block: 'start' });
    }, options));
    measure();
    schedule();
    cleanup.set(root, () => { controller.abort(); visibility.disconnect(); introResize.disconnect(); introBackdrop.remove(); document.body.classList.remove('mv-homepage'); cancelAnimationFrame(frame); cancelAnimationFrame(fireworksFrame); finishFireworks?.(); flight?.cancel(); flameFlight?.cancel(); rocketFlame.remove(); landing?.cancel(); });
  };
  const initPortfolio = () => document.querySelectorAll('[data-mv-portfolio]').forEach(root => {
    if (root.dataset.mvReady) return;
    root.dataset.mvReady = 'true';
    const controller = new AbortController();
    const options = {signal: controller.signal};
    root.querySelectorAll('[data-mv-comparison]').forEach(comparison => {
      const range = comparison.querySelector('input');
      const update = () => {
        comparison.style.setProperty('--mv-compare', range.value + '%');
        range.setAttribute('aria-valuetext', range.value + '% ' + root.querySelector('.mv-comparison-head span:first-child').textContent + ', ' + (100 - Number(range.value)) + '% ' + root.querySelector('.mv-comparison-head span:last-child').textContent);
      };
      range.addEventListener('input', update, options);
      update();
    });
    root.querySelectorAll('a[href^="#"]').forEach(link => link.addEventListener('click', event => {
      const target = document.getElementById(link.hash.slice(1));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({behavior: preference.matches ? 'auto' : 'smooth', block:'start'});
    }, options));
    cleanup.set(root, () => controller.abort());
  });
  const initBooks = () => document.querySelectorAll('[data-mv-book]').forEach(root => {
    if (root.dataset.bookReady) return;
    root.dataset.bookReady = 'true';
    const controller = new AbortController();
    const options = {signal:controller.signal};
    const pages = [...root.querySelectorAll('[data-book-page]')];
    const stage = root.querySelector('[data-book-stage]');
    const prev = root.querySelector('[data-book-prev]');
    const next = root.querySelector('[data-book-next]');
    const status = root.querySelector('[data-book-status]');
    const narrow = matchMedia('(max-width:749px)');
    let index = 0;
    let busy = false;
    let animation = null;
    let layer = null;
    let turnShadow = null;
    let turnAnimations = [];
    let pendingIndex = null;
    let previousMinHeight = '';
    const paint = () => {
      const count = narrow.matches ? 1 : 2;
      pages.forEach((page,i) => {page.hidden = i < index || i >= index + count;page.dataset.bookSide = i === index ? 'left' : 'right';});
      prev.disabled = index === 0;
      next.disabled = index + count >= pages.length;
      status.textContent = pages[index].dataset.bookChapter + ' · ' + String(index+1).padStart(2,'0') + (count === 2 ? '–' + String(Math.min(index+2,pages.length)).padStart(2,'0') : '') + ' / ' + pages.length;
      root.querySelectorAll('[data-book-jump]').forEach(button => { const start = Number(button.dataset.bookJump); const active = start === 8 ? index >= 8 : index >= start && index < start+2; button.setAttribute('aria-current',String(active)); });
    };
    const finishTurn = (commit = true) => {
      if (!busy) return;
      animation?.cancel();
      turnAnimations.forEach(effect => effect.cancel());
      layer?.remove();
      turnShadow?.remove();
      layer = null;
      turnShadow = null;
      animation = null;
      turnAnimations = [];
      stage.style.minHeight = previousMinHeight;
      delete stage.dataset.bookTurning;
      if (commit && pendingIndex !== null) index = pendingIndex;
      pendingIndex = null;
      busy = false;
      paint();
    };
    const copyPage = (page, width, height, offset) => {
      const copy = page.cloneNode(true);
      copy.hidden = false;
      copy.removeAttribute('data-book-page');
      copy.removeAttribute('id');
      copy.querySelectorAll('[id]').forEach(element => element.removeAttribute('id'));
      Object.assign(copy.style, {width:width+'px',height:height+'px',minHeight:'0',left:-offset+'px'});
      return copy;
    };
    const go = destination => {
      const step = narrow.matches ? 1 : 2;
      destination = clamp(destination,0,pages.length-step);
      if (!narrow.matches) destination -= destination % 2;
      if (busy || destination === index) return;
      const forward = destination > index;
      if (!preference.matches && stage.animate) {
        busy = true;
        pendingIndex = destination;
        previousMinHeight = stage.style.minHeight;
        stage.style.minHeight = stage.getBoundingClientRect().height + 'px';
        stage.dataset.bookTurning = forward ? 'forward' : 'backward';
        const mobile = narrow.matches;
        const frontPage = pages[mobile ? (forward ? index : destination) : (forward ? index+1 : destination+1)];
        const backPage = pages[forward ? destination : index];
        // Keep the old spread underneath until the turning leaf covers it.
        const leftUnder = mobile ? (forward ? destination : index) : (forward ? index : destination);
        const rightUnder = forward ? destination+1 : index+1;
        pages.forEach((page,i) => {
          page.hidden = i !== leftUnder && (mobile || i !== rightUnder);
          page.dataset.bookSide = i === leftUnder ? 'left' : 'right';
        });
        const inset = mobile ? 7 : 9;
        const width = (stage.clientWidth-inset*2)/(mobile ? 1 : 2);
        const height = stage.clientHeight-inset*2;
        const timing = {duration:1100,easing:'cubic-bezier(.4,0,.25,1)',fill:'both',direction:forward?'normal':'reverse'};
        turnShadow = document.createElement('div');
        turnShadow.className = 'mv-book__turn-shadow';
        turnShadow.setAttribute('aria-hidden','true');
        stage.append(turnShadow);
        turnAnimations.push(turnShadow.animate([{opacity:0},{opacity:.65,offset:.45},{opacity:0}],timing));
        layer = document.createElement('div');
        layer.className = 'mv-book__turn';
        layer.setAttribute('aria-hidden','true');
        layer.inert = true;
        layer.style.width = width+'px';
        const strips = 6;
        const stripWidth = width/strips;
        let parent = layer;
        for (let strip=0;strip<strips;strip++) {
          const segment = document.createElement('div');
          segment.className = 'mv-book__sheet-segment';
          // A subpixel overlap avoids light seams between the curved strips.
          segment.style.width = (stripWidth+.5)+'px';
          segment.style.left = strip===0 ? '0' : stripWidth+'px';
          for (const back of [false,true]) {
            const face = document.createElement('div');
            face.className = 'mv-book__sheet-face'+(back?' mv-book__sheet-face--back':'');
            const offset = back ? (strips-1-strip)*stripWidth-.5 : strip*stripWidth;
            const copy = copyPage(back?backPage:frontPage,width,height,offset);
            copy.dataset.bookSide = mobile || back ? 'left' : 'right';
            face.append(copy);
            const shade = document.createElement('div');
            shade.className = 'mv-book__sheet-shade';
            shade.style.backgroundSize = width+'px 100%';
            shade.style.backgroundPosition = -offset+'px 0';
            face.append(shade);
            segment.append(face);
            turnAnimations.push(shade.animate([{opacity:0},{opacity:.22,offset:.4},{opacity:.1,offset:.7},{opacity:0}],timing));
          }
          parent.append(segment);
          if (strip>0) turnAnimations.push(segment.animate([
            {transform:'rotateY(0deg)'},
            {transform:'rotateY(9deg)',offset:.3},
            {transform:'rotateY(6deg)',offset:.65},
            {transform:'rotateY(0deg)'}
          ],timing));
          parent = segment;
        }
        stage.append(layer);
        animation = layer.animate([
          {transform:'rotateY(0deg) translateZ(1px)'},
          {transform:'rotateY(-58deg) translateZ(14px)',offset:.35},
          {transform:'rotateY(-130deg) translateZ(9px)',offset:.72},
          {transform:'rotateY(-180deg) translateZ(1px)'}
        ],timing);
        animation.onfinish = () => finishTurn();
      } else { index = destination; paint(); }
    };
    prev.addEventListener('click',() => go(index-(narrow.matches?1:2)),options);
    next.addEventListener('click',() => go(index+(narrow.matches?1:2)),options);
    root.querySelectorAll('[data-book-jump]').forEach(button => button.addEventListener('click',()=>go(Number(button.dataset.bookJump)),options));
    root.addEventListener('keydown',event => {
      if (/INPUT|TEXTAREA|SELECT/.test(event.target.tagName)) return;
      if (event.key==='ArrowRight') {event.preventDefault();go(index+(narrow.matches?1:2));}
      if (event.key==='ArrowLeft') {event.preventDefault();go(index-(narrow.matches?1:2));}
    },options);
    let start = null;
    stage.addEventListener('pointerdown',event => {if(event.target.closest('a,button'))return;start={x:event.clientX,y:event.clientY};},options);
    stage.addEventListener('pointerup',event => {if(!start)return;const dx=event.clientX-start.x;const dy=event.clientY-start.y;start=null;if(Math.abs(dx)>55 && Math.abs(dx)>Math.abs(dy)*1.3)go(index+(dx<0?1:-1)*(narrow.matches?1:2));},options);
    stage.addEventListener('pointercancel',()=>{start=null;},options);
    narrow.addEventListener('change',()=>{finishTurn();if(!narrow.matches)index-=index%2;paint();},options);
    preference.addEventListener('change',event=>{if(event.matches)finishTurn();},options);
    paint();
    cleanup.set(root,()=>{controller.abort();finishTurn(false);});
  });
  let reveals = null;
  const initReveals = () => {
    if (preference.matches || window.Shopify?.designMode || !('IntersectionObserver' in window)) return;
    if (!reveals) {
      const scroll = scroller();
      reveals = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) entry.target.dataset.mvReveal = 'seen';
        else if (!entry.target.contains(document.activeElement)) entry.target.dataset.mvReveal = 'waiting';
      }), { root: scroll === window ? null : scroll, threshold: 0, rootMargin: '100px 0px -48px 0px' });
    }
    document.querySelectorAll('[data-mv-reveal]').forEach(element => {
      if (element.dataset.mvObserved) return;
      element.dataset.mvObserved = 'true';
      const rect = element.getBoundingClientRect();
      element.dataset.mvReveal = rect.top < innerHeight - 48 && rect.bottom > -100 ? 'seen' : 'waiting';
      reveals.observe(element);
    });
  };
  const init = () => {
    const surface = document.querySelector('.mellven-page-surface');
    if (surface && !surface.querySelector('.mv-site-backdrop') && !document.querySelector('.mv-free')) {
      const backdrop = document.createElement('div');
      backdrop.className = 'mv-site-backdrop';
      backdrop.setAttribute('aria-hidden','true');
      backdrop.innerHTML = '<svg viewBox="0 0 1600 1000" preserveAspectRatio="none"><g><path d="M480-80C180 160 450 330 930 230S1410-50 1710 100M-70 180C130 130 80 480 570 570S1000 470 1310 790S1600 530 1700 620M-80 960C180 870 190 680 470 790S890 1110 1220 940S1490 730 1720 900"/></g></svg>';
      surface.prepend(backdrop);
    }
    initHeader();
    initPortfolio();
    initBooks();
    document.querySelectorAll('[data-mv-home]').forEach(initHome);
    document.querySelectorAll('.mellven-about__intro,.mellven-about__projects,.mellven-about__process,.mellven-about__why,.mellven-offer__copy,.mellven-offer__visual,.mellven-offer__faq').forEach(element => { if (!element.hasAttribute('data-mv-reveal')) element.setAttribute('data-mv-reveal', ''); });
    document.querySelectorAll('main > .shopify-section').forEach(element => { if (!element.querySelector('.mv-home,.mellven-about,.mellven-offer') && !element.hasAttribute('data-mv-reveal')) element.setAttribute('data-mv-reveal', ''); });
    initReveals();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-mv-home],[data-mv-portfolio],[data-mv-book]').forEach(root => cleanup.get(root)?.()));
  document.addEventListener('focusin', event => { const target = event.target.closest?.('[data-mv-reveal]'); if (target) target.dataset.mvReveal = 'seen'; });
  preference.addEventListener('change', event => {
    if (event.matches) { reveals?.disconnect(); reveals = null; document.querySelectorAll('[data-mv-reveal]').forEach(element => { element.dataset.mvReveal = 'seen'; delete element.dataset.mvObserved; }); }
    else initReveals();
  });
})();
